import React from 'react';
import { useAuth } from '../context/AuthContext';
import DashboardGestionnaire from './DashboardGestionnaire';
import DashboardCoproprietaire from './DashboardCoproprietaire';
import DashboardPrestataire from './DashboardPrestataire';
import DashboardComptable from './DashboardComptable';
import SubAccountDashboard from './SubAccountDashboard';

const Dashboard = () => {
  const { user, token } = useAuth();

  if (user?.role === 'gestionnaire' || user?.role === 'admin' || user?.role === 'directeur_cabinet' || user?.role === 'assistant') {
    return <DashboardGestionnaire />;
  } else if (user?.role === 'comptable') {
    return <DashboardComptable />;
  } else if (user?.role === 'prestataire') {
    return <DashboardPrestataire />;
  } else if (user?.role === 'sous-compte') {
    return <SubAccountDashboard user={user} token={token} />;
  } else {
    return <DashboardCoproprietaire />;
  }
};

export default Dashboard;
